import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'Valeria T.',
  role: 'Docente de Biología | Guatemala',
  text: 'El material sobre biodiversidad neotropical le cambió la cara a mis alumnos. Por fin entienden por qué las especies de nuestro país están amenazadas y qué pueden hacer. Es el recurso más cercano a nuestra realidad que encontré. Lo uso desde la primera clase y los engancha de inmediato.'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  role: 'Profesor de Ciencias Naturales | Montevideo, Uruguay',
  text: 'El bono de evaluaciones vale por sí solo el precio del pack. Nunca más construí un examen de educación ambiental desde cero bajo presión. Salgo de cada trimestre con la satisfacción de tener todo resuelto.'
}, {
  initials: 'DG',
  name: 'Daniel G.',
  role: 'Docente de Geografía | Caracas, Venezuela',
  text: 'Los proyectos anuales transformaron el grupo más difícil que tenía. El Observatorio Climático Escolar hizo que mis alumnos llegaran a clases con datos reales de su ciudad. Eso no lo encontré en ningún otro material.'
}, {
  initials: 'AM',
  name: 'Ana M.',
  role: 'Docente de secundaria | Buenos Aires, Argentina',
  text: 'El glosario me devolvió el tiempo de clase. Antes perdía los primeros veinte minutos explicando qué es la huella ecológica o qué significa ENOS. Ahora mis alumnos llegan con el glosario leído y podemos ir directo al contenido.'
}, {
  initials: 'SR',
  name: 'Sebastián R.',
  role: 'Profesor de Ciencias Sociales | Quito, Ecuador',
  text: 'Las actividades integradoras fueron una revelación. Mis alumnos hicieron el juicio al carbono y debatieron durante dos clases seguidas con argumentos científicos reales. Eso cambió completamente el clima del aula.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-white" data-id="element-64">
      <div className="max-w-6xl mx-auto" data-id="element-65">
        <div className="text-center mb-16" data-id="element-66">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-green-dark" data-id="element-67">
            Lo que dicen los docentes que ya tienen su Mega Pack
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-68">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-beige-light border border-dark-border/10 p-8 rounded-2xl relative ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-69">
              <Quote className="absolute top-6 right-6 text-gold/20" size={48} data-id="element-70" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-71">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-72" />)}
              </div>

              <p className="text-dark/80 italic mb-8 relative z-10 leading-relaxed" data-id="element-73">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-74">
                <div className="w-12 h-12 rounded-full bg-green-light flex items-center justify-center text-green-dark font-bold text-lg border border-green-medium" data-id="element-75">
                  {t.initials}
                </div>
                <div data-id="element-76">
                  <div className="font-bold text-green-dark" data-id="element-77">{t.name}</div>
                  <div className="text-xs text-green-medium" data-id="element-78">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}